import React, { useContext, useState } from 'react'
import Card from '../../../common/card/Card'
import Button from '../../../common/button/Button'
import { MemberTableProvider } from './context/MemberTableContext'
import { TeamContext } from '../MenuTabs/MenuTabs'
import PendingInvites from './PendingInvites/PendingInvites'
import Members from './Members/Members'
import InviteLinks from './InviteLinks/InviteLinks'
import JoinRequests from './JoinRequests/JoinRequests'
import MemberPresets from './MemberPresets/MemberPresets'

const MemberNav = ({ teamType, refetchTeamData }) => {
  
  const { teamData } = useContext(TeamContext)
  const tabs = {
    members: {
      key: 'members',
      value: 'Members' 
    },
    /* manageMemberPresets: {
      key: 'manage-member-presets',
      value: 'Manage Member Presets' 
    } */
  }

  if ( teamData.team_type === 'wooteams' ) {
    tabs.pendingInvites = {
      key: 'pending-invites',
      value: 'Pending Invites'
    }
  } else if ( teamData.team_type === 'msynclicenses' && teamData.member_role !== 'member' ) {
    tabs.manageMemberPresets = {
      key: 'member-presets',
      value: 'Member Presets'
    }

    tabs.inviteLinks = {
      key: 'invite-links',
      value: 'Invite Links'
    }

    tabs.sentInvites = {
      key: 'sent-invites',
      value: 'Sent Invites'
    }

    tabs.joinRequests = {
      key: 'join-requests',
      value: 'Join Requests'
    }
  }

  const [ currentTab, setCurrentTab ] = useState(tabs.members.key)

  const renderComponent = () => {
    
    switch( currentTab ){
      case tabs.members.key:
        return (
          <MemberTableProvider>
            <Members teamType={teamType}/>
          </MemberTableProvider>
        )
      case tabs.pendingInvites?.key:
        return (
          <MemberTableProvider>
            <PendingInvites teamType={teamType}/>
          </MemberTableProvider>
        )
      case tabs.manageMemberPresets?.key:
        return(
          <MemberTableProvider>
            <MemberPresets teamType={teamType} refreshTeamData={ refetchTeamData } />
          </MemberTableProvider>
        )
      case tabs.inviteLinks.key:
        return(
          <MemberTableProvider>
            <InviteLinks teamType={teamType}/>
          </MemberTableProvider>
        )
      case tabs.sentInvites.key:
        return(
          <MemberTableProvider>
            <PendingInvites teamType={teamType}/>
          </MemberTableProvider>
        )
      case tabs.joinRequests.key:
        return(
          <MemberTableProvider>
            <JoinRequests teamType={teamType}/>
          </MemberTableProvider>
        )
      default:
        return (
          <Card> 
            <strong>Permission denied</strong> 
          </Card>
        )
    }
  }

  return (
    <Card>
      <div className='msync-card__header'>
        <ul className='msync-card__navigation'>
          {
            tabs && Object.keys(tabs).map((item) => {
              const items = tabs[item]
              return(
                <li>
                  <Button
                    key={items.key}
                    className={`${currentTab === items.key ? 'msync-button--is-style-link active' : 'msync-button--is-style-link msync-button--is-theme-secondary'}`}
                    onClick={() => setCurrentTab(items.key)}
                  >
                    <span>{items.value}</span>
                  </Button>
                </li>
              )
            })
          }
        </ul>
        { teamData.teamType === 'wooteams' && <div className='members-seat'>
          <span> <strong> { teamData.team_members_count ?? 0 }/{ teamData.team_seat_count ?? 'Unlimited' } </strong> seats used </span>
        </div> }
      </div>
      <div className='msync-card__body msync-card__body--has-table'>
        { renderComponent() }
      </div>
    </Card>
  )
}

export default MemberNav
